import { initData } from "@telegram-apps/sdk";
import { getMaxInitData } from "../utils/miniapp-platform";
import { Platform } from "./platform";

export const resolveInitDataForLogin = (platform: Platform): string | undefined => {
    if (platform === Platform.Max) {
        return getMaxInitData();
    }

    if (platform === Platform.Telegram) {
        if (!initData) return undefined;
        try { initData.restore(); }
        catch (error: unknown) {}
        return initData.raw();
    }

    // Desktop: try Telegram SDK if present; otherwise undefined (Api.login can use TEMP_INIT_DATA).
    if (!initData) return undefined;
    try { initData.restore(); }
    catch (error: unknown) {}
    return initData.raw();
};
